import { gql } from 'graphql-request'
import { useMutation } from '@/proxy/react-query'

import { client } from '@/proxy/client'
import { MutationDataError } from '@/resources/types'
import { ChangeOrderStatusInput, ChangeOrderStatusResponse } from './types'

import { monitorGraphqlOperation } from './datadogGraphql'

export const CHANGE_ORDER_STATUS = gql`
  mutation changeOrderStatus(
    $orderNumber: String!
    $status: OrderStatus!
    $reasons: String
    $attachments: String
  ) {
    changeOrderStatus(
      orderNumber: $orderNumber
      status: $status
      reasons: $reasons
      attachments: $attachments
    ) {
      ok
      errors {
        category
        target
        key
        args
        message
      }
    }
  }
`

export const useChangeOrderStatus = () =>
  useMutation<
    ChangeOrderStatusResponse,
    MutationDataError,
    ChangeOrderStatusInput
  >({
    mutationFn: (variables: ChangeOrderStatusInput) =>
      monitorGraphqlOperation({
        operationName: 'changeOrderStatus',
        variables,
        request: () => client.request(CHANGE_ORDER_STATUS, variables),
      }) as Promise<ChangeOrderStatusResponse>,
  })
